import React, { useState, useEffect } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import url from "../../function/url";
import Navbar from "./Navbar";
import "./Modal.css";
import { FaCheck, FaTimes, FaArrowRight } from "react-icons/fa";
import ReactPaginate from "react-paginate";
import Swal from "sweetalert2";

const AssignedBlacklistRequests = () => {
  const [assignedRequests, setAssignedRequests] = useState([]);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [rejectionReason, setRejectionReason] = useState("");
  const [furtherReason, setFurtherReason] = useState("");
  const [isRejectionModalOpen, setIsRejectionModalOpen] = useState(false);
  const [isFurtherModalOpen, setIsFurtherModalOpen] = useState(false);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 5;

  const [requests, setRequests] = useState([]);

const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      },
    });


  // Fetch assigned blacklist requests for the logged-in telecaller
  useEffect(() => {
    const logId = Cookies.get("log_id"); // Get telecaller ID from the cookie

    if (!logId) {
      setError("User not logged in or session expired. Please log in again.");
      setLoading(false);
      return;
    }

    console.log("Log ID:", logId);

    axios
      .get(`${url.path}/telecaller-dashboard-blacklist/`, {
        params: { log_id: logId },
        // withCredentials: true,
        headers: {
          "X-CSRFToken": Cookies.get("csrftoken"),
        },
      })
      .then((response) => {
        setAssignedRequests(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching requests:", error);
        setError("Failed to fetch assigned requests.");
        setLoading(false);
      });
  }, []);

  // Handle approval of a blacklist request
  const handleApprove = (request) => {
    axios
      .post(`${url.path}/approve-blacklist-request/`, {
        request_id: request.id,
      })
      .then(() => {
        Toast.fire({
          icon: "success",
          title: "Request Approved!",
        });
        
        setAssignedRequests((prevRequests) =>
          prevRequests.map((r) =>
            r.id === request.id ? { ...r, telecaller_status: "Approved" } : r
          )
        );
      })
      .catch((error) => {
        Toast.fire({
          icon: "error",
          title: "Error approving request",
        });
       
        console.error("Approval failed:", error);
      });
  };
  
  const handleRejection = () => {
    if (!rejectionReason) {
      Toast.fire({
        icon: "warning",
        title: "Please provide a reason for rejection.",
      });
    
      return;
    }
  
    axios
      .post(`${url.path}/reject-blacklist-request/`, {
        request_id: selectedRequest.id,
        reason: rejectionReason,
      })
      .then(() => {
        Toast.fire({
          icon: "success",
          title: "Request Rejected!",
        });
        
        setAssignedRequests((prevRequests) =>
          prevRequests.map((r) =>
            r.id === selectedRequest.id ? { ...r, telecaller_status: "Rejected" } : r
          )
        );
        setIsRejectionModalOpen(false);
        setRejectionReason("");
      })
      .catch((error) => {
        Toast.fire({
          icon: "error",
          title: "Error rejecting request",
        });
       
        console.error("Rejection failed:", error);
      });
  };
  
  const handleFurther = () => {
    if (!furtherReason) {
      Toast.fire({
        icon: "warning",
        title: "Please provide a reason to move this request further.",
      });

      
      return;
    }
  
    axios
      .post(`${url.path}/further-blacklist-request/`, {
        request_id: selectedRequest.id,
        further_reason: furtherReason,
      })
      .then(() => {
        Toast.fire({
          icon: "success",
          title: "Request moved further!",
        });
        
        setAssignedRequests((prevRequests) =>
          prevRequests.map((r) =>
            r.id === selectedRequest.id ? { ...r, telecaller_status: "In Progress" } : r
          )
        );
        setIsFurtherModalOpen(false);
        setFurtherReason("");
      })
      .catch((error) => {
        Toast.fire({
          icon: "success",
          title: "Error moving request further",
        });
        
        console.error("Further action failed:", error);
      });
  };
  
  const handleSearch = (event) => {
    const searchTerm = event.target.value.trim().toLowerCase();
    const rows = document.querySelectorAll("#documentTable tbody tr");

    rows.forEach((row) => {
      const rowText = row.textContent.toLowerCase();
      row.style.display = rowText.includes(searchTerm) ? "" : "none";
    });
  };

  const offset = currentPage * itemsPerPage;
  const currentItems = requests.slice(offset, offset + itemsPerPage);
  const pageCount = Math.ceil(requests.length / itemsPerPage);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };
  if (loading) {
    return <p>Loading requests...</p>;
  }

  if (error) {
    return <p>{error}</p>;
  }

  return (
    <div>
      <Navbar />
      <center>
      <h3  style={{ fontSize: "20px", position: "relative", top: "10px" }}>Assigned Blacklist Requests</h3>
      </center>
      <div className="page-wrapper">
        <div className="input-width">
        <input
          type="text"
          id="search"
          placeholder="Search in table..."
          onInput={handleSearch} // Attach the JavaScript-based search function
          className="search-input"
        />
        </div>
      
      </div>

      <div className="table-container">
      
        <table className="responsive-table" id="documentTable">
          <thead>
            <tr>
              <th>Employee Name</th>
              <th>Reason</th>
              <th>Approval Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {assignedRequests.length > 0 ? (
              assignedRequests.map((request) => (
                <tr key={request.id}>
                  <td>{request.Employee_Name}</td>
                  <td>{request.reason}</td>
                  <td>{request.telecaller_status || "Pending"}</td>
                  

<td>
  <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
    {/* Approve Button */}
    <button
      onClick={() => handleApprove(request)}
      disabled={
        request.telecaller_status === "In Progress" ||
        request.telecaller_status === "Approved" ||
        request.telecaller_status === "Rejected"
      }
      style={{
        backgroundColor:
          request.telecaller_status === "Approved" ||
          request.telecaller_status === "Rejected" ||
          request.telecaller_status === "In Progress"
            ? "#ccc"
            : "#28a745",
        color: "white",
        border: "none",
        borderRadius: "5px",
        padding: "5px 10px",
        display: "flex",
        alignItems: "center",
        gap: "5px",
        cursor:
          request.telecaller_status === "Approved" ||
          request.telecaller_status === "Rejected" ||
          request.telecaller_status === "In Progress"
            ? "not-allowed"
            : "pointer",
      }}
      title={
        request.telecaller_status === "Approved"
          ? "Already approved"
          : request.telecaller_status === "Rejected"
          ? "Action already taken"
          : request.telecaller_status === "In Progress"
          ? "Action in progress"
          : "Approve request"
      }
    >
      <FaCheck />
      {request.telecaller_status === "Approved" ? "Approved" : "Approve"}
    </button>

    {/* Reject Button */}
    <button
      onClick={() => {
        setSelectedRequest(request);
        setIsRejectionModalOpen(true);
      }}
      disabled={
        request.telecaller_status === "In Progress" ||
        request.telecaller_status === "Approved" ||
        request.telecaller_status === "Rejected"
      }
      style={{
        backgroundColor:
          request.telecaller_status === "Approved" ||
          request.telecaller_status === "Rejected" ||
          request.telecaller_status === "In Progress"
            ? "#ccc"
            : "#dc3545",
        color: "white",
        border: "none",
        borderRadius: "5px",
        padding: "5px 10px",
        display: "flex",
        alignItems: "center",
        gap: "5px",
        cursor:
          request.telecaller_status === "Approved" ||
          request.telecaller_status === "Rejected" ||
          request.telecaller_status === "In Progress"
            ? "not-allowed"
            : "pointer",
      }}
      title={
        request.telecaller_status === "Approved"
          ? "Action already taken"
          : request.telecaller_status === "Rejected"
          ? "Already rejected"
          : "Reject request"
      }
    >
      <FaTimes />
      {request.telecaller_status === "Rejected" ? "Rejected" : "Reject"}
    </button>

    {/* Further Button */}
    <button
      onClick={() => {
        setSelectedRequest(request);
        setIsFurtherModalOpen(true);
      }}
      disabled={
        request.telecaller_status === "In Progress" ||
        request.telecaller_status === "Approved" ||
        request.telecaller_status === "Rejected"
      }
      style={{
        backgroundColor:
          request.telecaller_status === "Approved" ||
          request.telecaller_status === "Rejected" ||
          request.telecaller_status === "In Progress"
            ? "#ccc"
            : "#007bff",
        color: "white",
        border: "none",
        borderRadius: "5px",
        padding: "5px 10px",
        display: "flex",
        alignItems: "center",
        gap: "5px",
        cursor:
          request.telecaller_status === "Approved" ||
          request.telecaller_status === "Rejected" ||
          request.telecaller_status === "In Progress"
            ? "not-allowed"
            : "pointer",
      }}
      title={
        request.telecaller_status === "Approved" ||
        request.telecaller_status === "Rejected" ||
        request.telecaller_status === "In Progress"
          ? "Action not allowed"
          : "Take further action"
      }
    >
      <FaArrowRight />
      {request.telecaller_status === "In Progress" ? "In Progress" : "Further"}
    </button>
  </div>
</td>

                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" style={{ textAlign: "center" }}>
                  No assigned requests found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {requests.length > itemsPerPage && (
        <ReactPaginate
          previousLabel={"← Previous"}
          nextLabel={"Next →"}
          breakLabel={"..."}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={3}
          onPageChange={handlePageClick}
          containerClassName={"pagination"}
          activeClassName={"active"}
        />
      )}
      {/* Rejection Reason Modal */}
      {isRejectionModalOpen && (
        <div className="employee-modal-overlay">
          <div className="employee-modal">
          <h3 className="employee-modal-title">Provide Reason for Rejection</h3>
          <textarea
            value={rejectionReason}
            onChange={(e) => setRejectionReason(e.target.value)}
            placeholder="Enter reason here"
            className="employee-input"
          ></textarea>
           <div className="employee-buttonContainer">
           <button onClick={handleRejection} className=" employee-modal-btn  employee-primaryButton">Submit</button>
           <button onClick={() => setIsRejectionModalOpen(false)} className="employee-modal-btn  employee-secondaryButton">Cancel</button>
           </div>
         
          </div>
         
        </div>
      )}

      {/* Further Reason Modal */}
      {isFurtherModalOpen && (
        <div className="employee-modal-overlay">
           <div className="employee-modal">
           <h3 className="employee-modal-title">Provide Reason for Moving Further</h3>
          <textarea
            value={furtherReason}
            onChange={(e) => setFurtherReason(e.target.value)}
            placeholder="Enter reason here"
            className="employee-input"
          ></textarea>
          <div className="employee-buttonContainer">
          <button onClick={handleFurther} className=" employee-modal-btn  employee-primaryButton">Submit</button>
          <button onClick={() => setIsFurtherModalOpen(false)} className="employee-modal-btn  employee-secondaryButton">Cancel</button>
          </div>

           </div>
        
        </div>
      )}
    </div>
  );
};

export default AssignedBlacklistRequests;
